// Environment configuration for different deployment stages
const config = {
  development: {
    debug: true,
    apiTimeout: 10000,
    enableAnalytics: false,
    logLevel: 'debug',
    WORKER_URL: 'https://google.shift.healthcare',
    apiBaseUrl: 'https://google.shift.healthcare'
  },
  staging: {
    debug: true,
    apiTimeout: 15000,
    enableAnalytics: true,
    logLevel: 'info',
    WORKER_URL: 'https://google.shift.healthcare',
    apiBaseUrl: 'https://google.shift.healthcare'
  },
  production: {
    debug: false,
    apiTimeout: 20000,
    enableAnalytics: true,
    logLevel: 'warn',
    WORKER_URL: 'https://google.shift.healthcare',
    apiBaseUrl: 'https://google.shift.healthcare'
  }
};

// Get current environment
const getEnvironment = () => {
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  if (process.env.REACT_APP_STAGE === 'staging') {
    return 'staging';
  }
  return 'development';
};

// Export current config
export const currentConfig = config[getEnvironment()];

// Helper functions
export const isDevelopment = () => getEnvironment() === 'development';
export const isProduction = () => getEnvironment() === 'production';
export const isStaging = () => getEnvironment() === 'staging';

// Feature flags
export const features = {
  enableDebug: currentConfig.debug,
  enableAnalytics: currentConfig.enableAnalytics
};

export default currentConfig;
